import { __module as c } from "./index136.js";
var v;
function _() {
  return v ? c.exports : (v = 1, function(u) {
    u.exports = f(d), u.exports.find = u.exports, u.exports.replace = function(r, n, e, a) {
      return f(O).call(this, r, n, e, a), r;
    }, u.exports.del = function(r, n, e) {
      return f(h).call(this, r, n, null, e), r;
    };
    function f(r) {
      return function(n, e, a, l) {
        var o = l && g(l.normalizer) ? l.normalizer : w;
        e = o(e);
        for (var t, i = !1; !i; ) z();
        function z() {
          for (t in n) {
            var p = o(t);
            if (e.indexOf(p) === 0) {
              var s = e.substr(p.length);
              if (s.charAt(0) === "." || s.length === 0) {
                e = s.substr(1);
                var x = n[t];
                if (x == null) {
                  i = !0;
                  return;
                }
                if (!e.length) {
                  i = !0;
                  return;
                }
                n = x;
                return;
              }
            }
          }
          t = void 0, i = !0;
        }
        if (t)
          return n == null ? n : r(n, t, a);
      };
    }
    function d(r, n) {
      if (r.hasOwnProperty(n)) return r[n];
    }
    function h(r, n) {
      return r.hasOwnProperty(n) && delete r[n], r;
    }
    function O(r, n, e) {
      return r.hasOwnProperty(n) && (r[n] = e), r;
    }
    function w(r) {
      return r.replace(/[^a-zA-Z0-9\.]+/g, "").toLowerCase();
    }
    function g(r) {
      return typeof r == "function";
    }
  }(c), c.exports);
}
export {
  _ as __require
};
//# sourceMappingURL=index112.js.map
